import { Controller, useFormContext } from 'react-hook-form';

import KDSOptionsList from '@decisiv/ui-components/lib/atoms/OptionsList';
import { OptionsListProps as KDSOptionsListProps } from '@decisiv/ui-components/lib/atoms/OptionsList/types';

interface OptionsListProps extends Omit<KDSOptionsListProps, 'onChange'> {
  name: string;
}

function OptionsList({ name, ...props }: OptionsListProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <KDSOptionsList
            name={name}
            onChange={onChange}
            selected={value}
            {...props}
          />
        );
      }}
    />
  );
}

export default OptionsList;
